<template>
	<div class="bc" v-if="items?.length">
		<template v-if="mode == 'catalogDetail'">
			<div class="cd-bc-items" ref="bcItemsContainer">
				<template v-for="(item, index) in items" :key="item">
					<NuxtLink v-if="index != items.length - 1" :to="item.url_without_domain">{{ item.title }}</NuxtLink>
				</template>
			</div>
		</template>
		<template v-else>
			<template v-for="(item, index) in items" :key="item">
				<NuxtLink v-if="index != items.length - 1" :to="item.url_without_domain">{{ item.title }}</NuxtLink>
				<span v-else class="bc-last">{{ item.title }}</span>
			</template>
		</template>
	</div>
</template>

<script setup>
	const props = defineProps(['items', 'mode']);
	const {mobileBreakpoint} = inject('rwd');

	const bcItemsContainer = ref();
	onMounted(async () => {
		//mobile container scroll
		if (bcItemsContainer.value && mobileBreakpoint) {
			const containerWidth = bcItemsContainer.value.scrollWidth;
			const documentWidth = document.documentElement.clientWidth;

			if (containerWidth > documentWidth) {
				let scrollLeft = bcItemsContainer.value.getBoundingClientRect().right;
				bcItemsContainer.value.scrollTo({
					left: scrollLeft,
					behavior: 'smooth',
				});
			}
		}
	});
</script>

<style scoped lang="less">
	.bc{
		display: flex; font-size: 12px; line-height: 1.2; color: var(--darkGray); padding-bottom: 16px;
		a{
			color: #fff; position: relative; padding-right: 15px; margin-right: 6px; text-underline-offset: 3px; text-decoration-color: var(--blue2);
			&:after{.icon-arrow-right(); font: 10px/1 var(--fonti); position: absolute; right: 0; top: 2px; color: var(--blue2);}
			&:hover{color: var(--blue2);}
		}
		@media (max-width: @m){
			color: var(--darkGray); padding-bottom: 10px;
			a{
				color: var(--blue); padding-right: 13px;
				&:after{color: var(--blue);}
			}
		}
	}
	.pd-bc{
		justify-content: center;
		:deep(span){display: none;}
		:deep(a){
			&:last-of-type{
				padding-right: 0; margin-right: 0;
				&:after{display: none;}
			}
		}
		@media (max-width: @t){
			:deep(a){color: var(--blue);}
		}
	}	
</style>